import * as actionTypes from '../actions/types';

const initialState = {
  trigger: {},
  guide: {},
  key: {},
  crisis: {},
  triumph: {},
  responsibility : {},
  pain: {},
  goal: {},
  triggerConnector: {},
  guideConnector: {},
  keyConnector: {},
  crisisConnector: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    /**
     * TODO: ADD IDEA
     *    action.stageName
     *    action.id
     *    action.personaId
     *    action.ideaContent
     *    action.chosen
     */
    case actionTypes.ADD_IDEA:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          [action.id]: {
            id: action.id,
            personaId : action.personaId,
            stageName: action.stageName,
            ideaContent: action.ideaContent,
            chosen: action.chosen,
          },
        },
      };

    /**
     * TODO: SELECT IDEA
     *    action.stageName
     *    action.ideaId
     */
    case actionTypes.SELECT_IDEA:
      let oldMilestoneIdeas = state[action.stageName];
      let newMilestoneIdeas = {};

      // Setting all old milestone ideas to not chosen
      if (action.personaId === null || action.personaId === '') {
        Object.keys(oldMilestoneIdeas).forEach((ideaKey) => {
          newMilestoneIdeas[ideaKey] = {
            ...oldMilestoneIdeas[ideaKey],
            chosen: false,
          };
        });
      } else {
        Object.keys(oldMilestoneIdeas).forEach((ideaKey) => {
          newMilestoneIdeas[ideaKey] = {
            ...oldMilestoneIdeas[ideaKey]
          };
        });
      }

      return {
        ...state,
        [action.stageName]: {
          ...newMilestoneIdeas,
          [action.ideaId]: {
            ...state[action.stageName][action.ideaId],
            chosen: action.chosen,
          },
        },
      };

    /**
     * TODO: UPDATE IDEA
     *    action.stageName
     *    action.ideaId
     *    action.content
     */
    case actionTypes.UPDATE_IDEA:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          [action.ideaId]: {
            ...state[action.stageName][action.ideaId],
            ideaContent: action.content
          },
        },
      };

    /**
     * TODO: DELETE IDEA
     *    action.stageName
     *    action.ideaId
     */
    case actionTypes.DELETE_IDEA:
      const { [action.stageName]: targetMilestone } = state;
      const {
        [action.ideaId]: deleteIdea,
        ...remainingIdeas
      } = targetMilestone;
      return {
        ...state,
        [action.stageName]: { ...remainingIdeas },
      };

    default:
      return state;
  }
};
